export class ApiError extends Error {
  constructor(message, status) {
    super(message);
    this.status = status;
  }

  // there may be some custom logic somewhere, let it be...
}
